import { BroadcastChannel } from 'broadcast-channel'

// Shared broadcast channel utility to prevent conflicts
class BroadcastChannelManager {
  private static instance: BroadcastChannelManager
  private channels: Map<string, BroadcastChannel> = new Map()

  private constructor() {}

  static getInstance(): BroadcastChannelManager {
    if (!BroadcastChannelManager.instance) {
      BroadcastChannelManager.instance = new BroadcastChannelManager()
    }
    return BroadcastChannelManager.instance
  }

  getChannel(name: string): BroadcastChannel {
    if (!this.channels.has(name)) {
      // Create new channel instance if one doesn't exist
      this.channels.set(name, new BroadcastChannel(name))
    }
    // Return existing or newly created channel instance
    return this.channels.get(name)!
  }

  closeChannel(name: string): void {
    const channel = this.channels.get(name)
    if (channel) {
      channel.close()
      this.channels.delete(name)
    }
  }

  closeAll(): void {
    this.channels.forEach((channel) => channel.close())
    this.channels.clear()
  }
}

// Export singleton instance
export const broadcastManager = BroadcastChannelManager.getInstance()

// Convenience functions
export const getBroadcastChannel = (name: string) =>
  broadcastManager.getChannel(name)
export const closeBroadcastChannel = (name: string) =>
  broadcastManager.closeChannel(name)

// Helper to parse broadcast messages consistently
export const parseBroadcastMessage = (msg: MessageEvent) => {
  let dupeCompareTo: string | undefined
  let productTitle: string | undefined

  if (msg.data && typeof msg.data === 'object') {
    dupeCompareTo = (msg.data as any).dupeCompareTo
    productTitle = (msg.data as any).productTitle
  } else {
    // Fallback for direct message object
    dupeCompareTo = (msg as any).dupeCompareTo
    productTitle = (msg as any).productTitle
  }

  return { dupeCompareTo, productTitle }
}
